// extracted by mini-css-extract-plugin
module.exports = {"root":"FileUpload_root__3nyMp","uploadIcon":"FileUpload_uploadIcon__Cz8FO","input":"FileUpload_input__mKJJp","fileList":"FileUpload_fileList__2dDsK"};